import {
  GET_ROOMS_INIT,
  GET_ROOMS_SUCCESS,
  GET_ROOMS_FAILED,
  GET_MESSAGES_INIT,
  GET_MESSAGES_FAILED,
  GET_MESSAGES_SUCCESS,
  UPLOAD_FILES_INIT,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_FILES_FAILED,
  ADD_SINGLE_MESSAGES,
  REMOVE_MESSAGES,
  UPDATE_ARCHIVE_INIT,
  UPDATE_ARCHIVE_SUCCESS,
  UPDATE_ARCHIVE_FAILED,
  GET_ARCHIVE_INIT,
  GET_ARCHIVE_SUCCESS,
  GET_ARCHIVE_FAILED,
  EMPTY_MESSAGES,
  SEEN_MESSAGES_INIT,
  SEEN_MESSAGES_SUCCESS,
  SEEN_MESSAGES_FAILED,
  ACTIVE_ROOM_UPDATE,
} from "./constants";
const initialState = {
  loading: false,
  rooms: [],
  archiveRooms: [],
  activeRoom:"",
  roomLoading: false,
  mesLoading: false,
  fileMessages: [],
  messageResult: {},
  updateArchive: {},
};
export default function chat(state = initialState, action) {
  switch (action.type) {
    case GET_ROOMS_INIT:
      return { ...state, roomLoading: true };
    case GET_ROOMS_SUCCESS:
      return { ...state, rooms: action.payload, roomLoading: false };
    case GET_ROOMS_FAILED:
      return { ...state, roomLoading: false };
    case UPLOAD_FILES_INIT:
      return { ...state, loading: true };
    case UPLOAD_FILES_SUCCESS:
      return { ...state, fileMessages: action.payload, loading: false };
    case UPLOAD_FILES_FAILED:
      return { ...state, loading: false };
    case ACTIVE_ROOM_UPDATE:
        var room = state.rooms.find(x=>x.id === action.payload);
        if(room){
          room.unSeenMessages = 0;
        }
        //  = [...state.rooms , room]
      return { ...state, activeRoom:action.payload, rooms: state.rooms };
    case GET_MESSAGES_INIT:
      return { ...state, mesLoading: true };
    case GET_MESSAGES_SUCCESS:
      let messages;
      if (!state.messageResult.items) {
        messages = action.payload.data;
      } else {
        action.payload.data.items = action.payload.data.items.concat(
          state.messageResult.items
        );
        messages = action.payload.data;
      }
      return { ...state, messageResult: messages, mesLoading: false };
    case GET_MESSAGES_FAILED:
      return { ...state, mesLoading: false };
    case EMPTY_MESSAGES:
      return { ...state, messageResult: {} };
    case ADD_SINGLE_MESSAGES:
      var roomList = state.rooms?.map((item) => {
        if (item?.id === action.message?.roomId && state.activeRoom === action.message?.roomId) {
          var message = action.message;
          item.lastText =  message.body ? message.body : message?.recordFiles?.length > 0 ? "File" : "";
          state.messageResult.items.push(action.message);
        }
        if (item?.id === action.message?.roomId && state.activeRoom !== action.message?.roomId) {
          var message = action.message;
          item.lastText =  message.body ? message.body : message?.recordFiles?.length > 0 ? "File" : "";
          item.unSeenMessages++;
        }
        return item;
      });
      return { ...state, messageResult: state.messageResult,rooms : roomList, loading: false };
    case REMOVE_MESSAGES:
      return { ...state, messageResult: {}, loading: false };
    case GET_ARCHIVE_INIT:
      return { ...state, loading: true };
    case GET_ARCHIVE_SUCCESS:
      return { ...state, archiveRooms: action.payload, loading: false };
    case GET_ARCHIVE_FAILED:
      return { ...state, loading: false };
    case UPDATE_ARCHIVE_INIT:
      return { ...state, loading: true };
    case UPDATE_ARCHIVE_SUCCESS:
      return { ...state, updateArchive: action.payload, loading: false };
    case UPDATE_ARCHIVE_FAILED:
      return { ...state, loading: false };
    case SEEN_MESSAGES_INIT:
      return { ...state, loading: true };
    case SEEN_MESSAGES_SUCCESS:
      return { ...state, loading: false };
    case SEEN_MESSAGES_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
